import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {Router} from '@angular/router';
import {Department, IScheduleRotation} from '@signal/asp-data-commons';
import {LuxonDateAdapter} from '../../services/luxon-date-adapter';
import {AddItemComponent} from '../add-item/add-item.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {Store} from '@ngrx/store';
import {IScheduleRotationLabelId, ScheduleRotationState} from '../../../store/schedule-rotation/schedule-rotation.reducer';
import {DeleteScheduleRotation, UpdateScheduleRotationName} from '../../../store/schedule-rotation/schedule-rotation.actions';
import {selectActiveScheduleRotationLabels} from '../../../store/schedule-rotation/schedule-rotation.selectors';
import {Observable} from 'rxjs';
import {SubscriptionList} from '../../models/asp.types';
import {unsubscribeSubscriptions} from '../../services/util.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styleUrls: ['./schedule-list.component.scss']
})
export class ScheduleListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() scheduleData: IScheduleRotation;
  labels: IScheduleRotationLabelId;
  subs: SubscriptionList = {};
  scheduleRotationLabel: string;
  scheduleRotationLabelDesc: string;

  constructor(private readonly luxonAdapter: LuxonDateAdapter,
              private readonly scheduleRotationState: Store<ScheduleRotationState>,
              private readonly router: Router,
              public readonly dialog: MatDialog, private readonly translate:TranslateService) {
  }

  ngOnInit() {
  }

  deleteSchedule($event, id: string) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'scheduleRotation.deleteScheduleConfirmation',
        popupBodyText: 'scheduleRotation.areYouSureDoYouWantToDeleteThisSchedule'
      },
      panelClass: 'asp-modal-container'
    });
    this.subs.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        this.scheduleRotationState.dispatch(new DeleteScheduleRotation({
          department: this.scheduleData.department,
          id: this.scheduleData.id
        }));
      }
    });
  }

  updateSchedule($event, schedule: IScheduleRotation) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(AddItemComponent, {
      width: '25rem',
      height: '18.625rem',
      panelClass: 'asp-modal-container',
      data: {isEditMode: true, title: 'scheduleRotation.editSchedule', formVal: schedule, type: 'schedule'},
      disableClose:true
    });
    this.subs.updateDialog = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        this.scheduleRotationState.dispatch(new UpdateScheduleRotationName({
          department: this.scheduleData.department,
          id: this.scheduleData.id,
          name: event.data.name
        }));
      }
    });
  }

  openSchedule(scheduleId: string) {
    const payload = {
      id: this.scheduleData.id
    };
    if (this.scheduleData.department === Department.SERVICE) {
      this.router.navigate(['asp/service/schedulerotation'], {queryParams: payload});
    } else {
      this.router.navigate(['asp/sales/schedulerotation'], {queryParams: payload});
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('scheduleData')) {
      /* unsubscribe */
      if (this.subs.labelsSub) {
        this.subs.labelsSub.unsubscribe();
      }

      this.subs.labelsSub = this.scheduleRotationState.select(selectActiveScheduleRotationLabels, {
        department: this.scheduleData.department,
        id: undefined
      }).subscribe(labels => {
        this.labels = labels;
        if (this.labels?.activeId === this.scheduleData.id) {
          this.scheduleRotationLabel = this.translate.instant('scheduleRotation.active');
          this.scheduleRotationLabelDesc = this.translate.instant('otherTexts.thisIsTheCurrentlyActiveScheduleRotation');
        } else if (this.labels?.upcomingId === this.scheduleData.id) {
          this.scheduleRotationLabel = this.translate.instant('scheduleRotation.upcoming');
          this.scheduleRotationLabelDesc = this.translate.instant('otherTexts.thisIsTheUpcomingScheduleRotation');
        } else if (this.labels?.inactiveIds?.includes(this.scheduleData.id)) {
          this.scheduleRotationLabel = this.translate.instant('scheduleRotation.inactive');
          this.scheduleRotationLabelDesc = this.translate.instant('otherTexts.thisIsTheInactiveScheduleRotationAndWillNotBecomeActiveUnlessStartDateIsModified');
        } else if (this.labels?.invalidIds?.includes(this.scheduleData.id)) {
          this.scheduleRotationLabel = this.translate.instant('otherTexts.invalid');
          this.scheduleRotationLabelDesc = this.translate.instant('otherTexts.thisIsTheInvalidScheduleRotationBecauseThereIsNoStartDateProvided');
        }
      });
    }
  }

  ngOnDestroy(): void {
    unsubscribeSubscriptions(this.subs);
  }


}
